import React, { FC, memo, useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { staticMultimedia, TStaticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
  partner: IPartner
}

interface IPartner {
  name: string,
  description: string
}

export const Partner: FC<IProps> = memo(({ partner }) => {
  const [top, setTop] = useState('15px')
  const [loaded, setLoaded] = useState(false)
  const imgBoxRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const positionTop = imgBoxRef.current?.offsetTop
    if (positionTop && loaded) {
      setTimeout(() => {
        setTop(`${positionTop}px`)
      }, 0)
    }
  }, [imgBoxRef.current, loaded])

  const onLoaded = () => {
    setLoaded(true)
  }

  const logoUrl = staticMultimedia[partner.name as TStaticMultimedia]
  return (
    <div className={styles.partnerBox}>
      <div className={styles.partnerBoxInner}>
        <img className={styles.logoResize}
             onLoad={onLoaded}
             style={{
               // @ts-ignore
               '--logoResizePositionTop': top
             }}
             src={logoUrl}
             alt="logo"/>

        <div className={styles.imgBox} ref={imgBoxRef}>
          <img className={styles.logo}
               src={logoUrl}
               alt="logo"/>
        </div>

        <div className={styles.description}>
          {partner.description}
        </div>
      </div>

    </div>
  )
})
